
import { Component,Prop,Watch, BaseMixins } from '@/lib';

import {domHelper} from '@/lib/utils'
const prefixCls = 'ivu-back-top'

@Component
export default class ABackTop extends BaseMixins {
    name:string = 'ABackTop';
    @Prop({type:Number,default:400}) height:number;
    @Prop({type:Number,default:30}) bottom:number;
    @Prop({type:Number,default:30}) right:number;
    @Prop({type:Number,default:1000}) duration:number;
    @Prop({default:window}) container:any;

    backTop:boolean =false;

    get classes () {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-show`]: this.backTop
        }
      ]
    }
    get styles () {
      return {
        bottom: `${this.bottom}px`,
        right: `${this.right}px`
      }
    }

    get innerClasses () {
      return `${prefixCls}-inner`
    }

    get containerEle () {
      return this.container === window ? window : document.querySelector(this.container)
    }

    handleScroll () {
      this.backTop = this.containerEle.scrollTop >= this.height
    }

    back () {
      let target = typeof this.container === 'string' ? this.containerEle : (document.documentElement || document.body)
      const sTop = target.scrollTop
      domHelper.scrollTop(this.containerEle, sTop, 0, this.duration)
      this.$emit('on-click')
    }

    mounted () {
        // window.addEventListener('scroll', this.handleScroll, false)
        // window.addEventListener('resize', this.handleScroll, false)
        domHelper.on(this.containerEle, 'scroll', this.handleScroll)
        domHelper.on(this.containerEle, 'resize', this.handleScroll)
    }

    beforeDestroy () {
        // window.removeEventListener('scroll', this.handleScroll, false)
        // window.removeEventListener('resize', this.handleScroll, false)
        domHelper.off(this.containerEle, 'scroll', this.handleScroll)
        domHelper.off(this.containerEle, 'resize', this.handleScroll)
    }
}
